import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const CellWrap = styled.div`
  vertical-align:middle;
  ${props => props.addStyle}
`

const CellPanel = styled.div`
  display: flex;
  flex-direction: column;
`

const Column = styled.th`
  text-align: right;
  padding-right: 1rem;
  height: 1rem;
`

const MonthTableHeaderWorkCell = ({ shiftDateCount, attendanceDateCount }) => {

  return (
    <CellWrap>
      <CellPanel>
        <Column>{shiftDateCount}</Column>
        <Column>{attendanceDateCount}</Column>
      </CellPanel>
    </CellWrap>
  )
}

MonthTableHeaderWorkCell.propTypes = {
    shiftDateCount: PropTypes.string,
    attendanceDateCount: PropTypes.string
}

export default MonthTableHeaderWorkCell
